import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, modalStore, ModalV1 } from '@feathr/components';

import * as styles from './Articles.css';

function FAQ() {
  const { t } = useTranslation();
  return (
    <div>
      <h1>Frequently Asked Questions</h1>
      <div className={styles.infoBlock}>
        <h2>What is Feathr?</h2>
        <p>
          Feathr is a business to business SaaS company, which sells a Digital Marketing Toolkit
          designed specifically for associations and organizations that host live events. The Feathr
          application allows its customers to collect web analytics data on their audience.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>How does Feathr collect web analytics data?</h2>
        <p>
          Cookies are small text files that web servers typically send to a user's computer when
          they visit a website. Cookies are stored as text files on the user's hard drive and can be
          accessed by web servers when the user visits a website or views an advertisement. Cookies
          can be used by companies as a way to identify a browser across multiple sessions.
        </p>
        <p>
          Feathr uses the standard “cookies” feature of major browser applications that allows us to
          store a small piece of data on a user's computer. These cookies allow Feathr to uniquely
          identify a browser across multiple web sessions up to 365 days apart. Feathr also uses a
          1×1 gif also known as a web-beacon, along with cookies, to capture web analytics data of
          the user interacting with our customer's website and other web content. This web-beacon
          sends non-personally identifiable information (non-PII) such as URL, time of visit, and
          screen size, to Feathr so we can provide insight to our customers on their audience's
          interactions with their online content.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>What cookies does Feathr store?</h2>
        <ul>
          <li>
            <label>Cookie Name:</label>f_id
            <ul>
              <li>
                <label>Description:</label>A 24 character hexadecimal text value stored for the
                purpose of browser identification across sessions.
              </li>
              <li>
                <label>Expiry:</label>365 days after the last visit to web content serviced by
                Feathr.
              </li>
            </ul>
          </li>
          <li>
            <label>Cookie Name:</label>feathr_session_id
            <ul>
              <li>
                <label>Description:</label>A 24 character hexadecimal text value stored for relating
                a set of web activity with a web session.
              </li>
              <li>
                <label>Expiry:</label>1 hour after the last visit to web content serviced by Feathr.
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className={styles.infoBlock}>
        <h2>What does Feathr collect?</h2>
        <p>
          By default, Feathr will only collect anonymous web behavioral data. The following list is
          an example of some of the data that Feathr collects by default.
          <ul>
            <li>
              <label>Created:</label>The time a web activity took place.
            </li>
            <li>
              <label>Creative Id:</label>A unique identifier to show what web content was served.
            </li>
            <li>
              <label>Session Id:</label>A unique identifier to connect a series of web activity to a
              session
            </li>
            <li>
              <label>Flavor:</label>A descriptor of the type of web activity. Example "Page View",
              and "Ad View"
            </li>
            <li>
              <label>Location URL:</label>The URL that the web activity took place on.
            </li>
            <li>
              <label>IP Address:</label>The IP of the device performing web activity.
            </li>
            <li>
              <label>Screen & Browser Dimensions:</label>Width and height of browser window, and
              screen.
            </li>
            <li>
              <label>Platform:</label>Operating system of device
            </li>
            <li>
              <label>Browser:</label>Chrome, Safari, IE... etc.
            </li>
          </ul>
        </p>
        <p>
          In addition to the default values collected by Feathr, our customers have the ability to
          send us additional data which may contain PII. Some examples of common PII our customers
          provide is email, name, and company
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>What does Feathr do with collected data?</h2>
        <p>
          The data collected by Feathr is processed so that our customers can segment their
          audiences into more specific groups which have expressed interest in their association or
          event. This is done for the purpose of their marketing efforts and provides targetable
          audiences for digital marketing campaigns.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>Who does Feathr provide my data to?</h2>
        <p>
          All data that is collected and processed by Feathr is privately shared between Feathr and
          the customer that provided the unprocessed data to Feathr. Feathr does not sell or release
          personally identifiable information to any third party vendors or data processors.
        </p>
        <p>
          Additionally, Feathr may disclose personal information in response to lawful requests by
          public authorities, including to meet national security or law enforcement requirements.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>Can I see, correct, and/or delete the info Feathr has about me?</h2>
        <p>
          Yes - For privacy reasons we require proof of identity before sharing PII. To get the
          process started please email <strong>privacy@feathr.co</strong>
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>How can I opt-out?</h2>
        <p>
          Simply{' '}
          <Button
            onClick={() => {
              document.cookie = 'do_not_collect=1; domain=.feathr.co; path=\\';
              modalStore.isModalOpen = true;
            }}
            type={'link'}
          >
            click here
          </Button>{' '}
          and we will apply an Opt-Out identifier and will stop collecting information from your
          browser for up to 1 year.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>How can I contact Feathr for inquiries or complaints?</h2>
        <p>
          Email <strong>privacy@feathr.co</strong> and we will respond as quickly as possible.
        </p>
      </div>
      <div className={styles.infoBlock}>
        <h2>Where can I find Feathr's official privacy policies?</h2>
        <p>
          Our official Privacy Policy can be found at{' '}
          <a href={'https://www.feathr.co/privacy-policy'}>www.feathr.co/privacy-policy</a>
        </p>
      </div>
      <ModalV1 cancelButtonText={'Close'} t={t}>
        <>
          <h1>Success!</h1>
          <div>
            Your id has been added to our do not collect list. Your web analytics data will no
            longer be recorded.
          </div>
        </>
      </ModalV1>
    </div>
  );
}

export default FAQ;
